import { DashboardShellData } from "../types/dashboardShellData";
import { useDashboardNeedsOrchestration } from "./useDashboardNeedsOrchestration";

export function useDashboardShellData(): DashboardShellData {
  const {
    needsList,
    isNeedsListLoading,
    isNeedsListFetching,
    needsListError,
    refetchNeedsList,
    isCreatingNeeds,
    isDashboardItemsLoading,
  } = useDashboardNeedsOrchestration();

  const isLoading = isDashboardItemsLoading || isCreatingNeeds || isNeedsListLoading;

  return {
    needsList,
    isNeedsListLoading,
    isNeedsListFetching,
    needsListError,
    refetchNeedsList,
    isCreatingNeeds,
    isLoading,
  };
}
